import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiChopin, API_CHOPIN } from '../config/index';
import { Observable } from 'rxjs';
import { Pagination, PeopleRequestParams, Person } from '@shared/interfaces';
import { map, mapTo } from 'rxjs/operators';

@Injectable()
export class PeopleService {
  constructor(
    @Inject(API_CHOPIN) private api: ApiChopin,
    private http: HttpClient
  ) {}

  getAll(params?: PeopleRequestParams): Observable<Pagination<Person>>{
    return this.http.get<Pagination<Person>>(this.api.PEOPLE(), { params: params as any });
  }

  get(id: number): Observable<Person>{
    return this.http.get<Person>(this.api.PEOPLE(id));
  }

  getSimilar(personId: number): Observable<Person[]>{
    return this.http.get<Pagination<Person>>(this.api.PEOPLE_SIMILAR(personId))
      .pipe(map(item => item.items));
  }

  setFavourite(id: number): Observable<boolean>{
    return this.http.post(this.api.PEOPLE_FAVORITE(), { person: id })
      .pipe(mapTo(true));
  }

  unsetFavourite(id: number): Observable<boolean>{
    return this.http.delete(this.api.PEOPLE_FAVORITE(id) )
      .pipe(mapTo(true));
  }

}
